import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Response } from '@shared/models/response.model';
import { RandomProject } from '@shared/interfaces/random-project.interface';
import { ProjectStatsistics } from '@shared/interfaces/project-statistics.interface';
import { Ambassador } from '@shared/interfaces/ambassador.interface';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(public baseHttp: BaseHttpService) {}

  getRandomProjectsImagesList(): Observable<Response<RandomProject[]>> {
    return this.baseHttp
      .get('/noauth/parameters/projects/random-pictrues')
      .pipe(map((resp) => resp as Response<RandomProject[]>));
  }

  getCounterStats(): Observable<Response<ProjectStatsistics>> {
    return this.baseHttp
      .get('/stats/counters')
      .pipe(map((resp) => resp as Response<ProjectStatsistics>));
  }

  getAmbassadors(): Observable<Response<Ambassador[]>> {
    return this.baseHttp.get('/ambassador').pipe(map((resp) => resp as Response<Ambassador[]>));
  }
}
